module.exports = __webpack_public_path__ + "img/choose-transfer-friday.2503273b.webp";